import React, { useEffect } from "react";
import { SkeletonLine, SkeletonBlock } from "@one-thd/sui-atomic-components";

export const SkeletonPlaceholder = () => {
  const [placeholderCount, setPlaceholderCount] = React.useState<number>(0);
  const SCREEN_SM = 640;
  const SCREEN_MD = 768;
  const SCREEN_LG = 1024;
  const SCREEN_XL = 1280;

  // Set the number of placeholders based on the screen size
  useEffect(() => {
    const windowWidth: number = window.innerWidth;
    if (windowWidth < SCREEN_SM) {
      setPlaceholderCount(2);
    } else if (windowWidth < SCREEN_MD || windowWidth < SCREEN_LG) {
      setPlaceholderCount(3);
    } else if (windowWidth < SCREEN_XL) {
      setPlaceholderCount(4);
    } else {
      setPlaceholderCount(6);
    }
  }, []);

  return (
    <div data-testid="pph-history-skeleton-loader">
      <header data-testid="skeleton-header" className="sui-flex sui-justify-between sui-pb-4">
        <div className="sui-w-1/3">
          <SkeletonLine variant="heading" />
        </div>
        <div className="sui-w-[100px]">
          <SkeletonLine fullWidth variant="heading" />
        </div>
      </header>
      <div
        data-testid="skeleton-block-container"
        className="sui-flex sui-gap-x-4 sui-min-h-[250px] sui-max-h-[330px]"
      >
        {
          // eslint-disable-next-line id-length
          Array.from({ length: placeholderCount }).map((_, index) => (
            <div
              data-testid="skeleton-block"
              key={index}
              className="sui-flex sui-flex-col sui-grow sui-gap-4 sui-pb-4"
            >
              <SkeletonBlock className="sui-block sui-bg-strong motion-safe:sui-animate-pulse sui-h-auto sui-w-full sui-rounded-none sui-aspect-square" />
              <SkeletonLine />
            </div>
          ))
        }
      </div>
      <footer data-testid="skeleton-footer" className="sui-flex sui-justify-between sui-pb-4">
        <div className="sui-w-3/4">
          <SkeletonLine variant="heading" />
        </div>
        <div className="sui-w-[100px]">
          <SkeletonLine fullWidth variant="heading" />
        </div>
      </footer>
    </div>
  );
};
